// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const nematvColors: ColorType = { ...colorPalette, primary: '#A020EF', secondary: '#A020EF' }

export const lightTheme = {
  colors: nematvColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: nematvColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: nematvColors.dark,
    secondary: nematvColors.grayText,
    disabled: nematvColors.dark,
    link: nematvColors.dark,
    hint: nematvColors.dark,
    highlight: nematvColors.primary,
    gray: nematvColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: nematvColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: nematvColors.dark,
    color: nematvColors.dark,
    border: nematvColors.primary,
    scrollbarThumb: nematvColors.primary,
    programTitle: nematvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: nematvColors.dark,
        selected: nematvColors.dark,
        progress: rgba(nematvColors.primary, 0.3),
        past: rgba(nematvColors.primary, 0.3),
        pastSelected: nematvColors.dark,
        pastHover: nematvColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(nematvColors.primary, 0.1),
      },
      text: {
        empty: nematvColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: nematvColors.dark,
    subTitle: nematvColors.grayText,
    bg: nematvColors.dark,
    number: nematvColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {
    signLogoSize: 158,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
